import OfferteFormPro from "@/components/feature/OfferteFormPro";

export default function OfferteForm() {
  return (
    <OfferteFormPro
      formId="offerte-kozijn-reparatie"
      formUrl="https://formspree.io/f/xgoqdank"
      defaultSubject="Kozijnreparatie"
    />
  );
}